// @flow

/**
 * getClassifiedsSite
 * @return {string|string} classifieds site from env or default value
 */
const getClassifiedsSite = (): string => {
  return process.env.CLASSIFIEDS_SITE || 'whatcar';
};

export default getClassifiedsSite;



// WEBPACK FOOTER //
// ./src/utils/getClassifiedsSite/index.js